<div class="bg-surface p-8 rounded-2xl border border-line flex flex-col items-center text-center gap-2">
	<mat-icon class="!w-8 !h-8 !text-3xl text-ink-subtle">inbox</mat-icon>
	@if (variant === 'no-competitors') {
	<p class="body-sm text-ink font-medium max-w-sm">{{ 'ANALYTICS_STATE.NO_COMPETITORS' | translate }}</p>
	} @else {
	<p class="body-sm text-ink font-medium">{{ 'ANALYTICS_STATE.NO_MENTIONS_TITLE' | translate }}</p>
	<p class="caption text-ink-subtle max-w-sm">{{ 'ANALYTICS_STATE.NO_MENTIONS_SUGGESTION' | translate }}</p>
	}
</div>
